import React from 'react';

export const AbsorbingIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="22"
    height="33"
    viewBox="0 0 22 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 32C16.5228 32 21 27.7019 21 22.4C21 20.714 20.5473 19.1296 19.7522 17.7526L19.6602 17.6L11.8972 1.82348C11.5308 1.07881 10.4691 1.07882 10.1027 1.82348L2.33972 17.6L2.24781 17.7526C1.45272 19.1296 1 20.714 1 22.4C1 27.7019 5.47715 32 11 32Z"
      stroke="url(#paint0_linear)"
      strokeWidth="1.6"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="5.57933"
        y1="22.6142"
        x2="23.0947"
        y2="19.3173"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
